/**
 * EULA and Privacy Policy document URLs (S3). Opens in new tab.
 */
export const DOCUMENT_EULA_URL: string = 'https://vantage-iot-global-public.s3.us-east-1.amazonaws.com/docs/Vantage+v2+-+EULA-1.0.pdf';
export const DOCUMENT_PRIVACY_POLICY_URL: string = 'https://vantage-iot-global-public.s3.us-east-1.amazonaws.com/docs/Vantage+v2+-+Privacy+Policy-1.0.pdf';
